import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { filter, map, of, switchMap } from 'rxjs';
import { ButtonTypeEnum } from '../../basic-features';
import { FeatureFlagConfigurationState, UserState } from '../../shared/';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "../../basic-features";
import * as i2 from "../../shared";
import * as i3 from "../../shared/services/file-converter.service";
import * as i4 from "./contact-form.service";
import * as i5 from "@ngxs/store";
import * as i6 from "@angular/common";
import * as i7 from "../../basic-features/side-modal-v2/side-modal-v2.component";
import * as i8 from "../../basic-features/select-v2/select-v2.component";
import * as i9 from "../../basic-features/textfield-v2/textfield-v2.component";
import * as i10 from "../../basic-features/button-v2/button.component";
import * as i11 from "@angular/forms";
import * as i12 from "../../basic-features/icon-v2/icon.component";
import * as i13 from "../../complex-components/attachments-v2/file-row/file-row.component";
import * as i14 from "../../basic-features/input-v2/input-v2.component";
import * as i15 from "@ngx-translate/core";
const _c0 = ["fileDropRef"];
function ContactFormSideModalComponent_geaui_textfield_v2_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-textfield-v2", 17);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.descriptionID)("group", ctx_r1.contactForm)("label", i0.ɵɵpipeBind1(1, 4, "UI-LIB.CONTACT-FORM.DESCRIPTION"))("required", true);
  }
}
function ContactFormSideModalComponent_geaui_input_v2_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-input-v2", 18);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.emailID)("group", ctx_r1.contactForm)("label", i0.ɵɵpipeBind1(1, 3, "UI-LIB.CONTACT-FORM.EMAIL"));
  }
}
function ContactFormSideModalComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.description, " ");
  }
}
function ContactFormSideModalComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 19);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "geaui-button-v2", 20);
    i0.ɵɵlistener("click", function ContactFormSideModalComponent_Conditional_14_Template_geaui_button_v2_click_4_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openSupportApp());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "UI-LIB.CONTACT-FORM.MACHINE-ISSUES-INFO"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("postIcon", true)("type", "tertiary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "UI-LIB.CONTACT-FORM.MACHINE-ISSUES-BUTTON.TEXT"), " ");
  }
}
function ContactFormSideModalComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, "UI-LIB.CONTACT-FORM.INFO"), " ");
  }
}
function ContactFormSideModalComponent_span_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "geaui-file-row", 21);
    i0.ɵɵlistener("removeFileByIndex", function ContactFormSideModalComponent_span_16_Template_geaui_file_row_removeFileByIndex_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRemoveFile($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const file_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("index", i_r6)("fileName", file_r5.file == null ? null : file_r5.file.name)("fileEnding", file_r5.ending)("canDelete", true);
  }
}
function ContactFormSideModalComponent_div_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "canvas", 23);
    i0.ɵɵelementStart(2, "geaui-icon-v2", 24);
    i0.ɵɵlistener("click", function ContactFormSideModalComponent_div_17_Template_geaui_icon_v2_click_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.createCaptcha());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "geaui-input-v2", 26);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clickable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 5, "UI-LIB.CONTACT-FORM.CAPTCHA-REQUEST"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r1.captchaID)("label", i0.ɵɵpipeBind1(7, 7, "UI-LIB.CONTACT-FORM.CAPTCHA"))("group", ctx_r1.contactForm);
  }
}
export class ContactFormSideModalComponent {
  snackService;
  contactService;
  fileConverterService;
  errorHandlerService;
  contactFormService;
  store;
  destroyed$;
  show = false;
  showUpload = true;
  showEmailInput = false;
  set selectedCategory(category) {
    const categoryControl = this.contactForm.get(this.categoryID);
    const isErrorCategory = category === 'Report error';
    this.categories = isErrorCategory ? this.errorCategory : this.otherCategories;
    isErrorCategory ? categoryControl?.disable() : categoryControl?.enable();
    categoryControl?.setValue(this.categories.find(c => c.value === category) || '');
    this.isError = isErrorCategory;
    this._selectedCategory = category;
  }
  description = '';
  set email(email) {
    if (email) {
      this.contactForm.get(this.emailID)?.setValue(email);
    } else {
      this.contactForm.get(this.emailID)?.setValue('');
    }
    this._email = email;
  }
  closeContactFormSideModal = new EventEmitter();
  fileInput;
  SUPPORT_APP_FEATURE = 'core_support.enabled';
  MACHINE_ISSUE_CATEGORY_VALUE = 'Machine issues';
  categoryID = 'category';
  descriptionID = 'description';
  emailID = 'email';
  captchaID = 'captcha';
  contactForm;
  isSending = false;
  ButtonType = ButtonTypeEnum;
  files = [];
  // ATTENTION - if you change the values of the categories also adjust the enum values in the gea-id backend.
  categories = [];
  errorCategory = [{
    nameKey: 'UI.LIB.CONTACT-FORM.REPORT-ERROR',
    value: 'Report error'
  }];
  otherCategories = [{
    nameKey: 'UI.LIB.CONTACT-FORM.GENERAL-QUESTION',
    value: 'General question'
  }, {
    nameKey: 'UI.LIB.CONTACT-FORM.REPORT-ISSUE',
    value: 'Report issue'
  }];
  _selectedCategory;
  isError = false;
  maxFileSize = 150000000;
  _email;
  resultCode = '';
  code = '';
  attachedFiles = [];
  constructor(snackService, contactService, fileConverterService, errorHandlerService, contactFormService, store, destroyed$) {
    this.snackService = snackService;
    this.contactService = contactService;
    this.fileConverterService = fileConverterService;
    this.errorHandlerService = errorHandlerService;
    this.contactFormService = contactFormService;
    this.store = store;
    this.destroyed$ = destroyed$;
    this.contactForm = new FormGroup({
      category: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required])
    });
  }
  ngOnInit() {
    this.categories = this.otherCategories;
    if (this.showEmailInput) {
      this.contactForm.addControl('email', new FormControl('', [Validators.email]));
      this.contactForm.addControl('captcha', new FormControl('', [Validators.required, this.validateFormCaptcha()]));
      this.createCaptcha();
    }
    this.contactForm.reset();
    if (this._selectedCategory) {
      this.contactForm.get(this.categoryID)?.setValue(this.categories.find(c => c.value === this._selectedCategory));
    }
    if (this._email) {
      this.contactForm.get(this.emailID)?.setValue(this._email);
    }
    this.store.select(UserState.authState).pipe(takeUntilDestroyed(this.destroyed$), filter(authState => authState !== "not set" /* AuthState.NotSet */), map(authState => authState === "logged in" /* AuthState.LoggedIn */)).subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.getFeatureFlags();
      }
    });
    this.contactFormService.contactFormCategory$.pipe(takeUntilDestroyed(this.destroyed$)).subscribe(category => {
      this.contactForm.get(this.categoryID)?.setValue(this.categories.find(c => c.value === category));
    });
    this.contactFormService.contactFormDescription$.pipe(takeUntilDestroyed(this.destroyed$)).subscribe(description => {
      this.contactForm.controls[this.descriptionID]?.setValue(description);
    });
  }
  validateFormCaptcha() {
    return control => {
      if (!control.value || control.value === this.resultCode) {
        return null;
      }
      return {
        captcha: true
      };
    };
  }
  getFeatureFlags() {
    this.store.select(FeatureFlagConfigurationState.features).pipe(takeUntilDestroyed(this.destroyed$), filter(features => !!features)).subscribe(features => {
      const hasSupportAppFeatureFlag = (this.SUPPORT_APP_FEATURE in features);
      if (hasSupportAppFeatureFlag) {
        const hasMachineIssueCategory = this.categories.find(value => value.value === this.MACHINE_ISSUE_CATEGORY_VALUE);
        if (!hasMachineIssueCategory) {
          this.categories = [...this.categories, {
            nameKey: 'UI.LIB.CONTACT-FORM.MACHINE-ISSUES',
            value: this.MACHINE_ISSUE_CATEGORY_VALUE
          }];
        }
      }
    });
  }
  onContactFormSubmit() {
    this.isSending = true;
    this.getContactMessage().pipe(switchMap(contactMessage => {
      if (contactMessage.email) {
        return this.contactService.sendContactMessagePublic(contactMessage);
      }
      return this.contactService.sendContactMessage(contactMessage);
    })).subscribe({
      next: () => this.handleSendMessageSuccess(),
      error: err => this.handleSendMessageError(err)
    });
  }
  onFilesAdded(event) {
    const files = event.target.files;
    if (files) {
      this.onFileDropped(files);
    }
  }
  onCloseContactFormSideModal() {
    this.cleanContactForm();
    this.closeContactFormSideModal.emit();
    if (this._selectedCategory) {
      this.contactForm.get(this.categoryID)?.setValue(this.categories.find(c => c.value === this._selectedCategory));
    }
  }
  onRemoveFile(index) {
    this.files.splice(index, 1);
    this.files = [...this.files];
    this.attachedFiles.splice(index, 1);
    this.attachedFiles = [...this.attachedFiles];
  }
  createCaptcha() {
    const char = Math.random().toString(24).substring(2, 6) + Math.random().toString(24).substring(2, 4);
    this.code = this.resultCode = char.toUpperCase();
    setTimeout(() => {
      const captchaCanvas = document.getElementById('captchaCanvas');
      const ctx = captchaCanvas.getContext('2d');
      if (!ctx) return;
      ctx.fillStyle = '#f2efd2';
      ctx.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height);
      ctx.beginPath();
      captchaCanvas.style.letterSpacing = 15 + 'px';
      ctx.font = '16px Arial';
      ctx.fillStyle = '#000000';
      ctx.textBaseline = 'middle';
      ctx.fillText(this.code, 40, 50);
      ctx.strokeStyle = '#2F9688';
      for (let i = 0; i < 150; i++) {
        ctx.moveTo(Math.random() * 300, Math.random() * 300);
        ctx.lineTo(Math.random() * 300, Math.random() * 300);
      }
      ctx.stroke();
    }, 100);
    // Generate captcha code and render it on canvas
  }
  onFileDropped(files) {
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (!file) continue;
      if (this.isMaxSizeGreaterThanFileSize(file)) {
        this.files.push(file);
      }
      this.attachedFiles = this.files.map(file => {
        const splitByDot = file.name.split('.');
        const fileEnding = splitByDot[splitByDot.length - 1];
        return {
          file,
          ending: fileEnding,
          isFileLoading: false
        };
      });
    }
    this.clearFileInput();
  }
  categoryChanged(selectOption) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this._selectedCategory = selectOption?.value;
  }
  openSupportApp() {
    const supportAppBaseUrl = this.contactFormService.getSupportAppBaseUrl;
    const createTicketPath = supportAppBaseUrl.endsWith('/') ? 'tickets/create' : '/tickets/create';
    window.open(supportAppBaseUrl + createTicketPath, '_blank');
  }
  getContactMessage() {
    const category = this.contactForm.get(this.categoryID)?.value;
    const description = this.buildDescriptionRequest();
    const systemInformation = `${this.createCurrentTimeStamp()} - ${window.navigator.appVersion}`;
    const userSession = `Url: ${location.href}`;
    const email = this.contactForm.get(this.emailID)?.value;
    const requestType = this.contactFormService.getContactFormRequestType;
    const contactMessage = {
      category: category.value,
      description,
      systemInformation,
      userSession,
      requestType
    };
    if (email) {
      contactMessage.email = email;
    }
    return this.fileConverterService.convertToBinaryFiles(this.files).pipe(switchMap(binaryFiles => {
      contactMessage.files = binaryFiles;
      return of(contactMessage);
    }));
  }
  isMaxSizeGreaterThanFileSize(file) {
    return !this.maxFileSize || this.maxFileSize >= file.size;
  }
  clearFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
  handleSendMessageSuccess() {
    this.snackService.add({
      severity: 'success',
      summary: 'Contact Message',
      detail: 'Your message has been sent'
    });
    this.isSending = false;
    this.onCloseContactFormSideModal();
  }
  cleanContactForm() {
    this.contactForm.reset();
    this.files = [];
  }
  handleSendMessageError(err) {
    this.isSending = false;
    if (err?.name === 'HttpErrorResponse') {
      this.errorHandlerService.handleErrorWithPrefix(err, 'UI-LIB');
      return;
    }
    this.errorHandlerService.bannerService.add({
      severity: 'error',
      summary: 'Contact Message',
      detail: 'Your message could not been sent',
      data: {
        hasCloseButton: true,
        hasBannerButton: false,
        bannerButtonLabel: ''
      }
    });
  }
  createCurrentTimeStamp() {
    const currentDate = new Date();
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZoneName: 'short'
    };
    return currentDate.toLocaleDateString('en-US', options);
  }
  ngOnDestroy() {
    this.fileInput = undefined;
  }
  buildDescriptionRequest() {
    const description = this.contactForm.get(this.descriptionID)?.value;
    if (this.isError) {
      return description + ' \n' + this.description;
    }
    return description;
  }
  static ɵfac = function ContactFormSideModalComponent_Factory(t) {
    return new (t || ContactFormSideModalComponent)(i0.ɵɵdirectiveInject(i1.SnackbarService), i0.ɵɵdirectiveInject(i2.ContactMessageApiService), i0.ɵɵdirectiveInject(i3.FileConverterService), i0.ɵɵdirectiveInject(i1.ErrorHandlerV2Service), i0.ɵɵdirectiveInject(i4.ContactFormService), i0.ɵɵdirectiveInject(i5.Store), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ContactFormSideModalComponent,
    selectors: [["geaui-contact-form-side-modal"]],
    viewQuery: function ContactFormSideModalComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
      }
    },
    inputs: {
      show: "show",
      showUpload: "showUpload",
      showEmailInput: "showEmailInput",
      selectedCategory: "selectedCategory",
      description: "description",
      email: "email"
    },
    outputs: {
      closeContactFormSideModal: "closeContactFormSideModal"
    },
    decls: 28,
    vars: 39,
    consts: [["fileDropRef", ""], [3, "closeSideModal", "modalTitle", "show", "showCloseIcon", "showFooterBorder"], ["side-modal-body", ""], [1, "gea-font-heading-16", "title"], [1, "contact-input-container", 3, "formGroup"], [3, "selectChanged", "id", "group", "label", "required", "options"], [3, "id", "group", "label", "required", 4, "ngIf"], [3, "id", "group", "label", 4, "ngIf"], [1, "contact-info-text"], [1, "machine-issue"], [4, "ngFor", "ngForOf"], ["class", "captcha-wrapper", 4, "ngIf"], ["side-modal-footer", ""], [1, "contact-attach-footer-container"], ["preIcon", "attach", 1, "attach-files-btn", 3, "click", "flex", "size", "disabled", "type"], ["preIcon", "send", 1, "contact-attach-send-button", 3, "click", "flex", "sending", "disabled", "type"], ["id", "fileDropRef", "type", "file", "multiple", "", 2, "display", "none", 3, "change"], [3, "id", "group", "label", "required"], [3, "id", "group", "label"], [1, "machine-issue-description"], ["size", "normal", 3, "click", "postIcon", "type"], [3, "removeFileByIndex", "index", "fileName", "fileEnding", "canDelete"], [1, "captcha-wrapper"], ["id", "captchaCanvas", "height", "80"], ["file", "24px_refresh", "color", "black", 1, "refresh-icon", 3, "click", "clickable"], [1, "captcha-text"], [3, "id", "label", "group"]],
    template: function ContactFormSideModalComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "geaui-side-modal-v2", 1);
        i0.ɵɵpipe(1, "translate");
        i0.ɵɵlistener("closeSideModal", function ContactFormSideModalComponent_Template_geaui_side_modal_v2_closeSideModal_0_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onCloseContactFormSideModal());
        });
        i0.ɵɵelementContainerStart(2, 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "form", 4)(8, "geaui-select-v2", 5);
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵlistener("selectChanged", function ContactFormSideModalComponent_Template_geaui_select_v2_selectChanged_8_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.categoryChanged($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, ContactFormSideModalComponent_geaui_textfield_v2_10_Template, 2, 6, "geaui-textfield-v2", 6)(11, ContactFormSideModalComponent_geaui_input_v2_11_Template, 2, 5, "geaui-input-v2", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, ContactFormSideModalComponent_Conditional_12_Template, 2, 1, "p", 8);
        i0.ɵɵelementStart(13, "p", 8);
        i0.ɵɵtemplate(14, ContactFormSideModalComponent_Conditional_14_Template, 7, 8, "div", 9)(15, ContactFormSideModalComponent_Conditional_15_Template, 2, 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ContactFormSideModalComponent_span_16_Template, 2, 4, "span", 10)(17, ContactFormSideModalComponent_div_17_Template, 8, 9, "div", 11);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementContainerStart(18, 12);
        i0.ɵɵelementStart(19, "div", 13)(20, "geaui-button-v2", 14);
        i0.ɵɵlistener("click", function ContactFormSideModalComponent_Template_geaui_button_v2_click_20_listener() {
          i0.ɵɵrestoreView(_r1);
          const fileDropRef_r8 = i0.ɵɵreference(27);
          return i0.ɵɵresetView(fileDropRef_r8.click());
        });
        i0.ɵɵtext(21);
        i0.ɵɵpipe(22, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "geaui-button-v2", 15);
        i0.ɵɵlistener("click", function ContactFormSideModalComponent_Template_geaui_button_v2_click_23_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onContactFormSubmit());
        });
        i0.ɵɵtext(24);
        i0.ɵɵpipe(25, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "input", 16, 0);
        i0.ɵɵlistener("change", function ContactFormSideModalComponent_Template_input_change_26_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onFilesAdded($event));
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("modalTitle", i0.ɵɵpipeBind1(1, 27, "UI-LIB.CONTACT-FORM.HEADER-TITLE"))("show", ctx.show)("showCloseIcon", true)("showFooterBorder", true);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.showEmailInput ? i0.ɵɵpipeBind1(5, 29, "UI-LIB.CONTACT-FORM.ALTERNATIVE-TITLE") : i0.ɵɵpipeBind1(6, 31, "UI-LIB.CONTACT-FORM.TITLE"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formGroup", ctx.contactForm);
        i0.ɵɵadvance();
        i0.ɵɵproperty("id", ctx.categoryID)("group", ctx.contactForm)("label", i0.ɵɵpipeBind1(9, 33, "UI-LIB.CONTACT-FORM.CATEGORY"))("required", true)("options", ctx.categories);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._selectedCategory !== ctx.MACHINE_ISSUE_CATEGORY_VALUE);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showEmailInput);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isError ? 12 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx._selectedCategory === ctx.MACHINE_ISSUE_CATEGORY_VALUE ? 14 : 15);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.attachedFiles);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showEmailInput);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("flex", true)("size", "small")("disabled", ctx.isSending || ctx._selectedCategory === ctx.MACHINE_ISSUE_CATEGORY_VALUE)("type", ctx.ButtonType.SECONDARY);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 35, "UI-LIB.CONTACT-FORM.ATTACH-FILES"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("flex", true)("sending", ctx.isSending)("disabled", ctx.contactForm.invalid || ctx._selectedCategory === ctx.MACHINE_ISSUE_CATEGORY_VALUE)("type", ctx.ButtonType.PRIMARY);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 37, "UI-LIB.CONTACT-FORM.SEND"), " ");
      }
    },
    dependencies: [i6.NgForOf, i6.NgIf, i7.SideModalV2Component, i8.SelectV2Component, i9.TextfieldV2Component, i10.ButtonV2Component, i11.ɵNgNoValidate, i11.NgControlStatusGroup, i11.FormGroupDirective, i12.IconComponent, i13.FileRowComponent, i14.InputV2Component, i15.TranslatePipe],
    styles: [".contact-input-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between}.title[_ngcontent-%COMP%]{margin-top:24px;margin-bottom:15px}.contact-info-text[_ngcontent-%COMP%]{display:inline-block;margin:0 0 16px;background:var(--geaui-grey-06);padding:16px;max-width:100%;overflow-wrap:break-word}.contact-info-text[_ngcontent-%COMP%]   .machine-issue[_ngcontent-%COMP%]{text-align:center}.contact-info-text[_ngcontent-%COMP%]   .machine-issue[_ngcontent-%COMP%]   .machine-issue-description[_ngcontent-%COMP%]{margin-bottom:16px}.contact-attach-send-button[_ngcontent-%COMP%]{margin-top:24px}.contact-attach-footer-container[_ngcontent-%COMP%], .captcha-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}.captcha-wrapper[_ngcontent-%COMP%]   #captchaCanvas[_ngcontent-%COMP%]{width:100%;margin-bottom:16px}.captcha-wrapper[_ngcontent-%COMP%]   .captcha-text[_ngcontent-%COMP%]{display:block;margin-top:16px}.captcha-wrapper[_ngcontent-%COMP%]   .refresh-icon[_ngcontent-%COMP%]{display:flex;align-self:flex-end}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactFormSideModalComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-contact-form-side-modal',
      template: "<geaui-side-modal-v2\n  [modalTitle]=\"'UI-LIB.CONTACT-FORM.HEADER-TITLE' | translate\"\n  [show]=\"show\"\n  [showCloseIcon]=\"true\"\n  [showFooterBorder]=\"true\"\n  (closeSideModal)=\"onCloseContactFormSideModal()\">\n  <ng-container side-modal-body>\n    <div class=\"gea-font-heading-16 title\">\n      {{ showEmailInput ? ('UI-LIB.CONTACT-FORM.ALTERNATIVE-TITLE' | translate) : ('UI-LIB.CONTACT-FORM.TITLE' | translate) }}\n    </div>\n    <form class=\"contact-input-container\" [formGroup]=\"contactForm\">\n      <geaui-select-v2\n        [id]=\"categoryID\"\n        [group]=\"contactForm\"\n        [label]=\"'UI-LIB.CONTACT-FORM.CATEGORY' | translate\"\n        [required]=\"true\"\n        [options]=\"categories\"\n        (selectChanged)=\"categoryChanged($event)\">\n      </geaui-select-v2>\n      <geaui-textfield-v2\n        *ngIf=\"_selectedCategory !== MACHINE_ISSUE_CATEGORY_VALUE\"\n        [id]=\"descriptionID\"\n        [group]=\"contactForm\"\n        [label]=\"'UI-LIB.CONTACT-FORM.DESCRIPTION' | translate\"\n        [required]=\"true\">\n      </geaui-textfield-v2>\n      <geaui-input-v2\n        *ngIf=\"showEmailInput\"\n        [id]=\"emailID\"\n        [group]=\"contactForm\"\n        [label]=\"'UI-LIB.CONTACT-FORM.EMAIL' | translate\">\n      </geaui-input-v2>\n    </form>\n    @if (isError) {\n      <p class=\"contact-info-text\">\n        {{ description }}\n      </p>\n    }\n    <p class=\"contact-info-text\">\n      @if (_selectedCategory === MACHINE_ISSUE_CATEGORY_VALUE) {\n        <div class=\"machine-issue\">\n          <div class=\"machine-issue-description\">\n            {{ 'UI-LIB.CONTACT-FORM.MACHINE-ISSUES-INFO' | translate }}\n          </div>\n\n          <geaui-button-v2 [postIcon]=\"true\" [type]=\"'tertiary'\" (click)=\"openSupportApp()\" size=\"normal\">\n            {{ 'UI-LIB.CONTACT-FORM.MACHINE-ISSUES-BUTTON.TEXT' | translate }}\n          </geaui-button-v2>\n        </div>\n      } @else {\n        {{ 'UI-LIB.CONTACT-FORM.INFO' | translate }}\n      }\n    </p>\n    <span *ngFor=\"let file of attachedFiles; index as i\">\n      <geaui-file-row\n        [index]=\"i\"\n        [fileName]=\"file.file?.name\"\n        [fileEnding]=\"file.ending\"\n        [canDelete]=\"true\"\n        (removeFileByIndex)=\"onRemoveFile($event)\">\n      </geaui-file-row>\n    </span>\n    <div class=\"captcha-wrapper\" *ngIf=\"showEmailInput\">\n      <canvas id=\"captchaCanvas\" height=\"80\"></canvas>\n      <geaui-icon-v2\n        class=\"refresh-icon\"\n        [clickable]=\"true\"\n        (click)=\"createCaptcha()\"\n        file=\"24px_refresh\"\n        color=\"black\"></geaui-icon-v2>\n      <span class=\"captcha-text\">{{ 'UI-LIB.CONTACT-FORM.CAPTCHA-REQUEST' | translate }}</span>\n      <geaui-input-v2 [id]=\"captchaID\" [label]=\"'UI-LIB.CONTACT-FORM.CAPTCHA' | translate\" [group]=\"contactForm\">\n      </geaui-input-v2>\n    </div>\n  </ng-container>\n  <ng-container side-modal-footer>\n    <div class=\"contact-attach-footer-container\">\n      <geaui-button-v2\n        class=\"attach-files-btn\"\n        [flex]=\"true\"\n        [size]=\"'small'\"\n        [disabled]=\"isSending || _selectedCategory === MACHINE_ISSUE_CATEGORY_VALUE\"\n        [type]=\"ButtonType.SECONDARY\"\n        (click)=\"fileDropRef.click()\"\n        preIcon=\"attach\">\n        {{ 'UI-LIB.CONTACT-FORM.ATTACH-FILES' | translate }}\n      </geaui-button-v2>\n      <geaui-button-v2\n        class=\"contact-attach-send-button\"\n        [flex]=\"true\"\n        [sending]=\"isSending\"\n        [disabled]=\"contactForm.invalid || _selectedCategory === MACHINE_ISSUE_CATEGORY_VALUE\"\n        [type]=\"ButtonType.PRIMARY\"\n        (click)=\"onContactFormSubmit()\"\n        preIcon=\"send\">\n        {{ 'UI-LIB.CONTACT-FORM.SEND' | translate }}\n      </geaui-button-v2>\n      <input id=\"fileDropRef\" #fileDropRef (change)=\"onFilesAdded($event)\" type=\"file\" multiple style=\"display: none\" />\n    </div>\n  </ng-container>\n</geaui-side-modal-v2>\n",
      styles: [".contact-input-container{display:flex;flex-direction:column;justify-content:space-between}.title{margin-top:24px;margin-bottom:15px}.contact-info-text{display:inline-block;margin:0 0 16px;background:var(--geaui-grey-06);padding:16px;max-width:100%;overflow-wrap:break-word}.contact-info-text .machine-issue{text-align:center}.contact-info-text .machine-issue .machine-issue-description{margin-bottom:16px}.contact-attach-send-button{margin-top:24px}.contact-attach-footer-container,.captcha-wrapper{display:flex;flex-direction:column}.captcha-wrapper #captchaCanvas{width:100%;margin-bottom:16px}.captcha-wrapper .captcha-text{display:block;margin-top:16px}.captcha-wrapper .refresh-icon{display:flex;align-self:flex-end}\n"]
    }]
  }], () => [{
    type: i1.SnackbarService
  }, {
    type: i2.ContactMessageApiService
  }, {
    type: i3.FileConverterService
  }, {
    type: i1.ErrorHandlerV2Service
  }, {
    type: i4.ContactFormService
  }, {
    type: i5.Store
  }, {
    type: i0.DestroyRef
  }], {
    show: [{
      type: Input
    }],
    showUpload: [{
      type: Input
    }],
    showEmailInput: [{
      type: Input
    }],
    selectedCategory: [{
      type: Input
    }],
    description: [{
      type: Input
    }],
    email: [{
      type: Input
    }],
    closeContactFormSideModal: [{
      type: Output
    }],
    fileInput: [{
      type: ViewChild,
      args: ['fileDropRef']
    }]
  });
})();
